import { AlertCircle, Info, Lightbulb, OctagonX, StickyNote, type LucideIcon } from "lucide-react";
import type { Tone } from "@/lib/blocks";

export interface ToneStyle {
  icon: LucideIcon;
  text: string;
  bg: string;
  border: string;
  stripe: string;
}

export const TONES: Record<Tone, ToneStyle> = {
  info: {
    icon: Info,
    text: "text-tone-info",
    bg: "bg-tone-info/[0.07]",
    border: "border-tone-info/30",
    stripe: "bg-tone-info",
  },
  tip: {
    icon: Lightbulb,
    text: "text-tone-tip",
    bg: "bg-tone-tip/[0.08]",
    border: "border-tone-tip/30",
    stripe: "bg-tone-tip",
  },
  warning: {
    icon: AlertCircle,
    text: "text-tone-warning",
    bg: "bg-tone-warning/[0.12]",
    border: "border-tone-warning/40",
    stripe: "bg-tone-warning",
  },
  danger: {
    icon: OctagonX,
    text: "text-tone-danger",
    bg: "bg-tone-danger/[0.07]",
    border: "border-tone-danger/30",
    stripe: "bg-tone-danger",
  },
  note: {
    icon: StickyNote,
    text: "text-tone-note",
    bg: "bg-muted/60",
    border: "border-border",
    stripe: "bg-tone-note",
  },
};

export function toneOf(v: unknown, fallback: Tone = "info"): Tone {
  return typeof v === "string" && v in TONES ? (v as Tone) : fallback;
}
